
import { Component, Vue, Prop } from "vue-property-decorator";

import UnitVersion from "@/models/unit/unit_version";
import TestVersion from "@/models/unit/unitable/test/version";

@Component({
  name: "CTestingsChangeSettings"
})
export default class CTestingsChangeSettings extends Vue {
  @Prop({ required: true }) public testing!: UnitVersion;
  @Prop({ required: false, default: false }) public disabled!: boolean;

  public can_reanswer_options = [
    { label: "Разрешить повторное прохождение", value: true },
    { label: "Запретить повторное прохождение", value: false }
  ];

  public unitable() {
    return this.testing?.unitable as TestVersion;
  }
}
